import Vue from 'vue'
import { URL_ORGANIZATION_DRAFT, URL_ORGANIZATION_DRAFT_REQUEST } from '@/constants/urls.js'
import { ORGANIZATION_DRAFT, ERRORS, AXIOS_REQUESTS, GENERAL_FILES } from '@/constants/store.js'
import { PARTICIPANT_TYPES } from '@/constants/business'

const state = {
  [ORGANIZATION_DRAFT.STATE.DRAFT_CHANGED]: true,
  [ORGANIZATION_DRAFT.STATE.DRAFT]: {
    organizationId: null,
    organizationShortName: null,
    organizationFullName: null,
    participantType: PARTICIPANT_TYPES.PARTICIPANT,
    registrationDate: null,
    country: null,
    managerFIO: null,
    managerPosition: null,
    inn: null,
    kpp: null,
    ogrn: null,
    // postAddress: null,
    // realAddress: null,
    location: null,
    email: null,
    phone: null,
    contactPerson: null,
    contactPersonPosition: null
  },
  [ORGANIZATION_DRAFT.STATE.REQUEST]: null
}

const actions = {
  async [ORGANIZATION_DRAFT.ACTIONS.MERGE_FIELDS] ({ commit }, draft) {
    commit(ORGANIZATION_DRAFT.MUTATIONS.MERGE_FIELDS, draft)
    commit(ORGANIZATION_DRAFT.MUTATIONS.DRAFT_CHANGED, true)
  },
  async [ORGANIZATION_DRAFT.ACTIONS.GET_ORGANIZATION_DRAFT] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFT.MUTATIONS.MERGE_FIELDS, resp.data || { participantType: PARTICIPANT_TYPES.PARTICIPANT })
    commit(ORGANIZATION_DRAFT.MUTATIONS.DRAFT_CHANGED, false)
  },
  async [ORGANIZATION_DRAFT.ACTIONS.CREATE_ORGANIZATION_DRAFT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFT.MUTATIONS.MERGE_FIELDS, resp.data)
    commit(ORGANIZATION_DRAFT.MUTATIONS.DRAFT_CHANGED, false)
  },
  async [ORGANIZATION_DRAFT.ACTIONS.UPDATE_ORGANIZATION_DRAFT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFT.MUTATIONS.MERGE_FIELDS, resp.data)
    commit(ORGANIZATION_DRAFT.MUTATIONS.DRAFT_CHANGED, false)
  },
  async [ORGANIZATION_DRAFT.ACTIONS.GET_ORGANIZATION_REGISTRATION_REQUEST] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT_REQUEST}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFT.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUEST, resp.data)
  },
  async [ORGANIZATION_DRAFT.ACTIONS.SEND_ORGANIZATION_REGISTRATION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT_REQUEST}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    // commit(ORGANIZATION_DRAFT.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUEST, resp.data)
  },
  async [ORGANIZATION_DRAFT.ACTIONS.GET_REGISTRATION_CARD] ({ commit, dispatch }) {
    const url = `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT}/registrationCard?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [ORGANIZATION_DRAFT.ACTIONS.CLEAR_ORGANIZATION_DRAFT] ({ commit }) {
    commit(ORGANIZATION_DRAFT.MUTATIONS.CLEAR_ORGANIZATION_DRAFT)
    commit(ORGANIZATION_DRAFT.MUTATIONS.DRAFT_CHANGED, true)
  },
  async [ORGANIZATION_DRAFT.ACTIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUEST] ({ commit }) {
    commit(ORGANIZATION_DRAFT.MUTATIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUEST)
  }
}

const mutations = {
  [ORGANIZATION_DRAFT.MUTATIONS.DRAFT_CHANGED] (state, flag) {
    state[ORGANIZATION_DRAFT.STATE.DRAFT_CHANGED] = flag
  },
  [ORGANIZATION_DRAFT.MUTATIONS.MERGE_FIELDS] (state, editedFieldsObj) {
    for (const key in editedFieldsObj) {
      state[ORGANIZATION_DRAFT.STATE.DRAFT][key] = editedFieldsObj[key]
    }
  },
  [ORGANIZATION_DRAFT.MUTATIONS.CLEAR_ORGANIZATION_DRAFT] (state) {
    for (const key in state[ORGANIZATION_DRAFT.STATE.DRAFT]) {
      state[ORGANIZATION_DRAFT.STATE.DRAFT][key] = null
    }
  },
  [ORGANIZATION_DRAFT.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUEST] (state, request) {
    state[ORGANIZATION_DRAFT.STATE.REQUEST] = request
  },
  [ORGANIZATION_DRAFT.MUTATIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUEST] (state) {
    state[ORGANIZATION_DRAFT.STATE.REQUEST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
